import { TripLegMode } from "types/map";

export const DEFAULT_TRIP_LEG_MODE: TripLegMode = "drive";

const LEG_MODE_CODES: Record<TripLegMode, string> = {
  drive: "d",
  fly: "f",
  walk: "w",
  bike: "b",
  train: "t",
};

const CODE_TO_LEG_MODE: Record<string, TripLegMode> = {
  d: "drive",
  f: "fly",
  w: "walk",
  b: "bike",
  // Legacy share code for removed e-bike mode → bike
  e: "bike",
  t: "train",
};

export const padTripLegModes = (
  modes: TripLegMode[] | undefined,
  hopCount: number
): TripLegMode[] => {
  const next = (modes ?? []).slice(0, hopCount);

  while (next.length < hopCount) {
    next.push(DEFAULT_TRIP_LEG_MODE);
  }

  return next;
};

export const encodeTripLegModes = (modes: TripLegMode[]): string =>
  modes.map((mode) => LEG_MODE_CODES[mode] ?? "d").join("");

export const decodeTripLegModes = (
  encoded?: string,
  hopCount?: number
): TripLegMode[] => {
  const decoded = (encoded ?? "")
    .split("")
    .filter((code) => Boolean(CODE_TO_LEG_MODE[code]))
    .map((code) => CODE_TO_LEG_MODE[code]);

  if (hopCount === undefined) {
    return decoded;
  }

  return padTripLegModes(decoded, hopCount);
};

export const hasFlyLeg = (modes: TripLegMode[]): boolean =>
  modes.some((mode) => mode === "fly");

export const hasNonDriveLeg = (modes: TripLegMode[]): boolean =>
  modes.some((mode) => mode !== "drive");
